import type { ReactNode, ForwardedRef, MouseEventHandler } from 'react';
import { forwardRef } from 'react';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './NoneStyleButton.module.scss';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  className?: string;
};

const cls = cssModules(STYLES);

const NoneStyleButton = (
  { children, className, onClick, ...rest }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) => (
  <button
    {...rest}
    type="button"
    ref={ref}
    onClick={onClick}
    className={cls('NoneStyleButton', className)}
  >
    {children}
  </button>
);

export default forwardRef(NoneStyleButton);
